/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserCountryResponse } from '../../models/user-country-response';

export interface MembersMeCountryGet$Params {
  'CF-Connecting-IP'?: string;
}

export function membersMeCountryGet(
  http: HttpClient,
  rootUrl: string,
  params?: MembersMeCountryGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<UserCountryResponse>> {
  const rb = new RequestBuilder(rootUrl, membersMeCountryGet.PATH, 'get');
  if (params) {
    rb.header('CF-Connecting-IP', params['CF-Connecting-IP'], {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserCountryResponse>;
      }),
    );
}

membersMeCountryGet.PATH = '/members/me-country';
